import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { ConnectWithZoho, IntegrationBenefits, Uninstall } from "./components";
import { Zoho as ZohoIcon } from "../../../../assets";
import {
  ClassNames,
  getCookie,
  // getDataFromDb,
  // updateDataInDb,
} from "../../../../helper";
import { FaAngleLeft } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { getDataFromMongoDb, updateDataInMongoDb } from "../../../../services/mongod.data";

const CF_Zoho_API_URL =
  "https://us-central1-causalfunnel-21.cloudfunctions.net/CF_Zoho_server";

const Zoho = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const zohoAuthCode = queryParams.get("code");

  const [install, setInstall] = useState(false);
  const [integration, setIntegration] = useState(false);
  const [integrationData, setIntegrationData] = useState({});
  const [open, setOpen] = useState(false);

  const [accessToken, setAccessToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [lists, setLists] = useState([]);
  const [page, setPage] = useState(1);
  const [authName, setAuthName] = useState("");
  const [listId, setListId] = useState("");

  const installHandler = (state) => setInstall(state);

  useEffect(() => {
    if (!integration) setIntegrationData({});
  }, [integration]);

  useEffect(() => {
    setAuthName(`${uuidv4()} Zoho account`);
  }, []);

  useEffect(() => {
    if (!zohoAuthCode && !refreshToken) return;

    if (zohoAuthCode) {
      setInstall(true);
    }

    const fetchData = async () => {
      try {
        let postData = {};
        if (refreshToken) {
          postData = {
            refreshToken,
          };
        } else {
          postData = {
            code: zohoAuthCode,
          };
        }

        const response = await axios.post(CF_Zoho_API_URL, postData);
        const { access_token, refresh_token, data, lists } = response.data;

        if (access_token) {
          setAccessToken(access_token);
          setRefreshToken(refresh_token);
          setIntegrationData(data);
          setLists(lists);

          // let api_url = `${user}/graph-integration/zoho`;
          // updateDataInDb(api_url, {
          //   data,
          //   accessToken: access_token,
          //   refreshToken: refresh_token ? refresh_token : refreshToken,
          //   lists,
          // });
          await updateDataInMongoDb(user, "graph-integration", ["zoho" ], {
            data,
            accessToken: access_token,
            refreshToken: refresh_token ? refresh_token : refreshToken,
            lists,
          });

          setIntegration(true);
          navigate({ replace: true, search: "" });
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchData();
  }, [zohoAuthCode, refreshToken]);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      try {
        // let api_url = `${user}/graph-integration/zoho`;
        // let result = await getDataFromDb(api_url);
        let apiData = await getDataFromMongoDb(user, "graph-integration");
        let result = apiData.data.zoho || apiData.data.data.zoho;

        if (result) {
          setIntegration(true);
          setIntegrationData(result?.data);
          setAccessToken(result?.accessToken);
          setRefreshToken(result?.refreshToken);
          setLists(result?.lists);
          setListId(result?.listId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [user]);

  return (
    <div className="bg-gray-200 w-full p-3 relative">
      <NavLink
        to="/integration"
        className="text-indigo-600 text-lg text-semibold flex gap-1 items-center "
      >
        <FaAngleLeft className="text-sm" />
        Go back
      </NavLink>
      <div className="bg-white p-4 rounded-md my-3">
        <header className="flex justify-between items-center border-bottom">
          <div className="my-3 flex items-center gap-3">
            <ZohoIcon className="grayscale" />
            <p className="text-lg font-semibold">Zoho</p>
          </div>
          {integration && !install ? (
            <div className="space-x-2">
              <button
                className={ClassNames(
                  "text-gray-700 border p-1.5 rounded-md px-3.5 hover:cursor-pointer hover:bg-gray-100"
                )}
                onClick={() => setOpen(true)}
              >
                Uninstall
              </button>
              <button
                className={ClassNames(
                  "text-indigo-700 bg-indigo-200 p-1.5 rounded-md px-3.5 hover:bg-indigo-300 hover:cursor-pointer"
                )}
                onClick={() => setInstall(true)}
              >
                Configure
              </button>
            </div>
          ) : (
            <button
              className={ClassNames(
                "text-white bg-indigo-600 p-1.5 rounded-md px-3.5 hover:bg-indigo-500 hover:cursor-pointer",
                install ? "hidden" : ""
              )}
              onClick={() => setInstall(true)}
            >
              Install Zoho
            </button>
          )}
        </header>
        {install ? (
          <ConnectWithZoho
            installHandler={installHandler}
            integration={integration}
            integrationData={integrationData}
            page={page}
            setPage={setPage}
            authName={authName}
            setAuthName={setAuthName}
            lists={lists}
            user={user}
            listId={listId}
            setListId={setListId}
          />
        ) : (
          <div className="relative">
            <Uninstall
              open={open}
              setOpen={setOpen}
              setIntegration={setIntegration}
            />
            <IntegrationBenefits />
          </div>
        )}
      </div>
    </div>
  );
};

export default Zoho;
